import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-vendor-setup',
  templateUrl: './vendor-setup.component.html',
  styleUrls: ['./vendor-setup.component.scss']
})
export class VendorSetupComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor-setup/vendor-setup.component.ts